import React, { Suspense, lazy, useEffect } from 'react';
import JrgAppBar from './JrgAppBar';
import { Outlet, useNavigate } from 'react-router';
import { useAuth0 } from '@auth0/auth0-react';

// Lazy load chat component since it's not immediately needed
const FloatingChatButton = lazy(() => import('./Chat/FloatingChatButton'));
import { createTheme } from '@mui/material/styles';
import { Box, ThemeProvider } from '@mui/material';

// Component to handle post-login redirect (must be inside Router context)
function AuthRedirectHandler() {
  const { isAuthenticated } = useAuth0();
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated) {
      const redirectPath = sessionStorage.getItem('auth_redirect_path');
      if (redirectPath && redirectPath !== '/' && redirectPath !== window.location.pathname) {
        console.log('Redirecting to stored path:', redirectPath);
        sessionStorage.removeItem('auth_redirect_path');
        navigate(redirectPath);
      }
    }
  }, [isAuthenticated, navigate]);

  return null;
}

const theme = createTheme({
  palette: {
    primary: {
      main: '#59484D',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#D9A282',
    },
    text: {
      primary: '#2C4A47', // Darker version of #B8D9D5
      secondary: '#59484D',
    },
    background: {
      default: '#59484D',
      paper: '#FFFFFF',
    },
    chat: {
      ai: '#2C4A47',
      user: '#FFFFFF',
      timestamp: {
        ai: '#666666',
        user: '#E0E0E0',
      },
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      {/* Handle post-login redirect */}
      <AuthRedirectHandler />
      {/* Skip to main content link for accessibility */}
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:absolute focus:top-2 focus:left-2 focus:z-50 focus:bg-white focus:px-4 focus:py-2 focus:rounded focus:shadow-lg focus:text-primary"
      >
        Skip to main content
      </a>
      <Box className="h-screen flex flex-col w-full relative">
        <JrgAppBar/>
        <Box
          component="main"
          id="main-content"
          tabIndex={-1}
          className="flex-1 overflow-y-auto overflow-x-hidden relative min-h-0"
        >
          <Outlet/>
        </Box>
        <Suspense fallback={null}>
          <FloatingChatButton/>
        </Suspense>
      </Box>
    </ThemeProvider>
  );
}

export default App;
